import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import { colors } from '../theme/designTheme';

const Layout = ({ children }) => (
  <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: colors.bg }}>
    <Sidebar />
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: '100vh',
        minWidth: 0,
        bgcolor: colors.bg,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default Layout;
